<template>
  <v-app>
    <Loader/>
    <Snackbar/>
    <router-view></router-view>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar'
import Loader from '@/components/Loader'

export default {
  name: 'App',
  components: {
    Loader,
    Snackbar
  }
}
</script>
